// extracted by mini-css-extract-plugin
module.exports = {"backButton":"voltar_backButton__25mnN"};